import { Amplify } from 'aws-amplify';
import { signOut, getCurrentUser, signInWithRedirect, fetchAuthSession } from 'aws-amplify/auth';

export const API_BASE = process.env.REACT_APP_API_BASE ?? 'https://api.sahayy.com';

const configs: Record<string, { userPoolId: string; clientId: string; domain: string; region: string }> = {
  '': {
    // Empty = proxy mode, currently pointing to prod
    userPoolId: 'eu-central-1_54ainkEbD',
    clientId: '5m191d9urmq78qj5jmientn3v2',
    domain: 'sahayy.auth.eu-central-1.amazoncognito.com',
    region: 'eu-central-1',
  },
  'https://dev.api.sahayy.com': {
    userPoolId: 'eu-west-1_BqRregGG5',
    clientId: '597hrspagr71j2mhqn77mmj3qp',
    domain: 'sahayy-dev.auth.eu-west-1.amazoncognito.com',
    region: 'eu-west-1',
  },
  'https://api.sahayy.com': {
    userPoolId: 'eu-central-1_54ainkEbD',
    clientId: '5m191d9urmq78qj5jmientn3v2',
    domain: 'sahayy.auth.eu-central-1.amazoncognito.com',
    region: 'eu-central-1',
  },
};

export const cfg = configs[API_BASE] || configs['https://api.sahayy.com'];

const redirectUrl = window.location.origin + '/';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: cfg.userPoolId,
      userPoolClientId: cfg.clientId,
      loginWith: {
        oauth: {
          domain: cfg.domain,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [redirectUrl],
          redirectSignOut: [redirectUrl],
          responseType: 'code',
          providers: ['Google', 'Apple'],
        },
      },
    },
  },
});

export async function socialSignIn(provider: 'Google' | 'Apple') {
  await signInWithRedirect({ provider });
}

export async function getAuthToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() || null;
  } catch {
    return null;
  }
}

export async function getUser() {
  try {
    return await getCurrentUser();
  } catch {
    return null;
  }
}

export async function logOut() {
  await signOut();
}
